import React from 'react';
import { Grid } from '@mui/material';
import InputField from '../../../Components/InputField';

export default function AttendanceConfirmation({ params = {}, submitType }) {
  return (
    <Grid container spacing={2} sx={{ marginTop: '10px' }}>
      <Grid item xs={12}>
        <InputField
          name="status"
          type="radio"
          required
          disabled={params?.readonlyAfterRegistration && submitType === 'update'}
          options={[
            { name: params.acceptText, value: 'accepted' },
            { name: params.declineText, value: 'declined' },
          ]}
        />
      </Grid>
    </Grid>
  );
}
